import { render, staticRenderFns } from "./update-info.vue?vue&type=template&id=6d3973f9&scoped=true&"
import script from "./update-info.vue?vue&type=script&lang=js&"
export * from "./update-info.vue?vue&type=script&lang=js&"
import style0 from "./update-info.vue?vue&type=style&index=0&id=6d3973f9&lang=scss&scoped=true&"
import style1 from "./update-info.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3973f9",
  null
  
)

export default component.exports